import React from 'react';


export default function MainMenu() {

    return (
        <></>
    )
}